<template>
  <div class="MailAddressChange">
    <section-header v-if="isChange" heading="2" ja="メールアドレスを変更する"/>
    <section-header v-else heading="2" ja="メールアドレスを登録する"/>
    <div class="discription">
      <p>入力したメールアドレスに、確認用メールを送ります。</p>
      <p>現在のメールアドレス：</p>
      <p>{{nowMailAddress}}</p>
      <p>新しいメールアドレス：</p>
    </div>
    <p-text-field
      placeholder="メールアドレス"
      v-model="local"
      @click="onLocalCancel">
    </p-text-field>
    <rule v-if="domain === 'それ以外'">@以降も全て入力してください</rule>
    <p-select
      :items="domains"
      v-model="domain">
    </p-select>
    <normal-btn :disabled="!validForm" @click="onSend">送信</normal-btn>
  </div>
</template>

<script>
import NormalBtn from '../components/NormalBtn'
import PSelect from '../components/PSelect'
import PTextField from '../components/PTextField'
import SectionHeader from '../components/SectionHeader'
import Rule from '../components/Rule'
import Protobuf from '../mixins/protobuf'
import Screen from '../mixins/screen.js'
import Validator from '../mixins/validator'
import { domains } from "../assets/js/domain";
import { decodeUrlSafeBase64 } from "../assets/js/util"

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "MailAddressChange",
  components: {
    NormalBtn,
    PSelect,
    PTextField,
    SectionHeader,
    Rule
  },
  mixins: [
    Protobuf,
    Screen,
    Validator
  ],
  data () {
    return {
      nowMailAddress: '',
      local: '',
      domain: '',
      domains: domains
    }
  },
  computed: {
    isChange() {
      return this.$store.getters.mailAddress !== ''
    },
    mailAddress() {
      if(this.domain === 'それ以外') {
        return this.local;
      } else {
        return this.local + this.domain;
      }
    },
    validForm() {
      const err = this.validMailAddress(this.mailAddress)
      if (err !== null) {
        return false
      }
      return true
    }
  },
  methods: {
    onLocalCancel() {
      this.local = ''
    },
    onSend() {
      const cmdNo = pb.PlayerUpdateInfoReq.CommandNo.COMMAND_NO
      const message = pb.PlayerUpdateInfoReq.create({
        updateType: pb.PlayerUpdateInfoReq.UpdateType.MAIL_ADDRESS,
        mailAddress: this.mailAddress
      })
      const encorded = pb.PlayerUpdateInfoReq.encode(message).finish()
      this.post(cmdNo, encorded)
        .then(decoded => {
          if (decoded.status === pb.PlayerUpdateInfoResp.Status.SUCCESS) {
            this.$router.push({ name: 'mailAddressChangeConfirmation', params: { mailAddress: this.mailAddress } })
          } else {
            this.$_error('Error', { title: 'メールアドレス入力', statusCode: 100 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'メールアドレス入力', statusCode: 100 })
        })
    }
  },
  mounted() {
    this.nowMailAddress = this.$store.getters.mailAddress
    this.domain = domains[0]
    if(this.$route.params.playerId) {
      if(decodeUrlSafeBase64(this.$route.params.playerId) !== this.$store.getters.md5playeerId) {
        // アカウント不一致
        const cmdNo = pb.LogoutReq.CommandNo.COMMAND_NO
        const message = pb.LogoutReq.create({
          token: this.$store.getters.token
        })
        const encoded = pb.LogoutReq.encode(message).finish()
        this.post(cmdNo, encoded)
          .then(decoded => {
            if (decoded.status === pb.LogoutResp.Status.SUCCESS) {
              this.$store.dispatch('logout')
              this.$router.push({ path: '/login', query: { to: '/mailAddressChange' } })
            } else {
              this.$_error('Error', { title: 'プロフィール', statusCode: 413 })
            }
          })
          .catch(() => {
            this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.discription {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p { margin-top: 10px; }
}
</style>
